<template>
    <NebulaBlockMessage v-bind="boundProps" class="careers-block-message" icon="warning--filled" contained @closeBlockMessage="emit('close')">
        <template #action v-if="actionTitle">
            <NebulaButton type="ghost" :text="actionTitle" size="s" @click="actionTrigger" icon-left="arrow-right" />
        </template>
    </NebulaBlockMessage>
</template>

<script setup>
import { NebulaBlockMessage, NebulaButton } from '@discoveryedu/nebula-components';
import { computed } from 'vue';

const emit = defineEmits({
    close: () => true, // Callback trigger, no payload provided
});

const { header, color, description, actionTitle, actionTrigger, dismissible } = defineProps({
    header: String,
    color: String,
    description: String,
    actionTitle: String,
    actionTrigger: Function,
    dismissible: {
        type: Boolean,
        default: true,
    },
});

const boundProps = computed(() => {
    return {
        header: header,
        color: color,
        description: description,
        dismissible: dismissible,
    };
});
</script>
